import React, { Component } from "react";
import GolfUpdateRowNew from "./GolfUpdateRowNew";
import golflist from "../golflist.json";
import golflistbis from "../golflist2.json";
//import sun from "sun-time";


class GolfUpdateForm extends Component {
  constructor(props) {
    super(props);
    let golflist1 = golflist.golflist;
    let golflist2 = golflistbis.golflist;
    console.log(golflist1);
    console.log(golflist2);

    this.state = {
      today: {golflist: golflist1,
      curTime: new Date()}, tomorrow: {golflist: golflist2,
        curTime: new Date()}
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleCallbackChange = this.handleCallbackChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAddTimeslot = this.handleAddTimeslot.bind(this);
    this.handleDeleteTimeslot = this.handleDeleteTimeslot.bind(this);
    this.handleButton = this.handleButton.bind(this);

  }
  componentDidMount() {
    setInterval(() => {
      this.setState({
        curTime: new Date()
      });
    }, 1000);

    fetch("/golfstatus")
      .then(
        response => {
          return response.json();
        },
        err => {
          console.log("error", err);
        }
      )
      .then(data => {
        if (data !== undefined && data.timestamp !== "0") {
          let latest = new Date(data.timestamp);
          let today = new Date();
          if (
            latest.getDate() === today.getDate() &&
            latest.getMonth() === today.getMonth() &&
            latest.getFullYear() === today.getFullYear()
          ) {
            console.log("Updating state after download.");
            this.setState({today: {
              golflist: data.golflist,
              timestamp: data.timestamp}
            });
          }
        }
      });

      console.log("Fetching state of tomorrow at: "+" /golfstatus?day"+this.props.tomorrow)
      fetch("/golfstatus?day="+this.props.tomorrow)
      .then(
        response => {
          return response.json();
        },
        err => {
          console.log("error", err);
        }
      )
      .then(data => {
        if (data !== undefined && data.timestamp !== "0") {
          let latest = new Date(data.timestamp);
          let today = new Date();
          if (
            latest.getDate() === today.getDate() &&
            latest.getMonth() === today.getMonth() &&
            latest.getFullYear() === today.getFullYear()
          ) {
            console.log("Updating state after download.");
            this.setState({tomorrow: {
              golflist: data.golflist,
              timestamp: data.timestamp}
            });
          }
        }
      });



  }

  handleChange(event) {
    console.log("EVENT RECEIVED FROM ID: " + event.id);
    //this.setState({ value: event.target.value });
  }
  handleButton(day) {
    console.log(day);
    let daystring = day.day === "today"?this.props.today:this.props.tomorrow;

    
    //this.setState({ value: event.target.value });
    this.handleSubmit(day.day,daystring);
  }
  handleAddTimeslot(event) {
    let day=event.day
    let newState = { ...this.state};

    console.log("Ready to add to State: Adding timeslot for: " + event.golf+"On the day of: "+day);
    console.log(newState[day].golflist)

    console.log(newState);
    newState[day].golflist.map(zone => {
      console.log(zone);
      if (zone.name === event.golf) {
        console.log("Hoera, we updaten !");
//        var sun=require('sun-time');
//        console.log(sun(50.026823, 5.501409))
//        console.log(sun(50.026823, 5.501409))
          var SunCalc = require('suncalc');
          //Zaventem
          let times = SunCalc.getTimes(new Date(), 50.89615039907642, 4.502018873062446)
          let sunsetH = times.sunset.getHours();
          let sunsetM = times.sunset.getMinutes()

        let afl = 55
        let ash = 18
        let aeh = 23
        let aem = 59

        if (zone.name.includes("GA")){
          afl = 65
          ash = 11
          aeh = sunsetH
          aem = sunsetM 
        }
        else if(zone.name.includes("G1"))
          afl = 55
        else if(zone.name.includes("G2"))
          afl = 75
        else if(zone.name.includes("G3"))
          afl = 65
        else if(zone.name.includes("G5"))
          afl = 95




        zone.slots.push({
          "FL": afl,
          "tp": 0,
          "sh": ash,
          "sm": 0,
          "eh": aeh,
          "em": aem
        })
        console.log("na de update")
        console.log(newState)

      }
      return null;
    });
    this.setState(newState);
    console.log(newState);

  }
  handleDeleteTimeslot(golf,slot,day) {
    console.log("Ready to delete from State: Deleting timeslot for: " + golf);
    console.log("Ready to delete from State: Deleting timeslot for: " + slot);

    let newState = { ...this.state };
    newState[day].golflist.map(zone => {
      if (zone.name === golf) {
        console.log("UPDATING STATE LODE: slicing slot: "+slot);
        console.log("UPDATING STATE LODE: for golf: "+zone.name);
        zone.slots.splice(slot,1);
      }
      return null;
    });
    console.log(newState)
    this.setState(newState);

  }
  handleCallbackChange(id, value,day) {
    console.log("EVENT RECEIVED FROM ID: " + id + " with value " + value);
    //this.setState({ value: event.target.value });
    let name = id.split("-")[1];
    let prop = id.split("-")[0];
    let slot = id.split("-")[3];
    console.log("name: " + name);
    console.log("prop: " + prop);
    console.log("slot: " + slot);

    let newState = { ...this.state };
    newState[day].golflist.map(zone => {
      if (zone.name === name) {
        console.log("UPDATING STATE LODE");
        console.log("Are we changing state of transponder? "+(prop === "tp"));
        console.log("Current State of prop: "+zone[prop]);

        if (prop === "tp") {
          console.log("Doing Special Trick.");
          zone.slots[slot][prop] = zone.slots[slot][prop] == "1" ? 0 : 1;
        }
        else
          zone.slots[slot][prop] = value;
      }
      return null;
    });
    console.log(newState)
    this.setState(newState);
  }

  handleSubmit(day, daystring) {
    console.log(day)
    console.log("Push Update to Server for day"+day+" met string"+daystring);
    console.log(this.state);
    window.scrollTo(0, 0);
    //console.log("Event Value: "+event.value);

    fetch("/golfstatusupdate", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        golflist: this.state[day].golflist,
        user: this.props.user,
        day: daystring
      })
    });

    /*
    fetch("/golfstatus?day="+day)
      .then(response => response.json())
      .then(data => {
        console.log(data);
        let newState  = {...this.state}
        newState[day].golflist = data.golflist;
        newState[day].golflist = data.timestamp;
        this.setState(newState);
      });
    */
   
    this.setState({ showAlert: 1 });
    setTimeout(() => {
      this.setState({ showAlert: 0 });
    }, 3000);
    //this.props.formUpdate();

    //event.preventDefault();
  }
  handleCallbackUpdate = golf => {
    console.log("handleCallbackUpdate");
    console.log(golf);
    let newState = JSON.parse(JSON.stringify(this.state));
    newState.golflist.map(item => {
      if (item.name === golf.name) {
        console.log("UPDATING STATE");
        item.status = golf.status;
      }
      return golf.status;
    });
    this.setState(newState);
  };

  render() {
    let alert = this.state.showAlert ? (
      <div className="alert alert-primary" role="alert">
        Update Successfully pushed to the server!
      </div>
    ) : (
      ""
    );
    return (
      <div>
        {alert}
        <div className="alert alert-success" role="alert">
           {"All Times below are to be entered as Local Time (LT)."}
        </div>
        <div className="alert alert-success" role="alert">
           {"Today: "+this.props.today}
        </div>

        <form onSubmit={() => this.handleSubmit({day: "today"})}>
          <table className="table table-striped table-sm">
            <thead className="thead-dark">
              <tr>
                <th>Name</th>
                <th>Status</th>
                <th>Add Timeslot</th>
                <th>Transponder Mandatory?</th>
                <th>FL</th>
                <th>Start Hour</th>
                <th>Start Minutes</th>
                <th>End Hour</th>
                <th>End Minutes</th>
                <th>Delete Slot</th>

              </tr>
            </thead>
            <tbody align="center">
              {this.state["today"].golflist.map(golf => (
                <GolfUpdateRowNew
                  golf={golf.name}
                  slots={golf.slots}
                  key={golf.name+"-"+this.props.today}
                  tp={golf.tp}
                  status={golf.status}
                  FL={golf.FL}
                  sh={golf.sh}
                  sm={golf.sm}
                  eh={golf.eh}
                  em={golf.em}
                  curTime={this.state.curTime}
                  callbackUpdate={this.handleCallbackUpdate}
                  callbackOnChange={this.handleCallbackChange}
                  handleAddTimeslot={this.handleAddTimeslot}
                  handleDeleteTimeslot={this.handleDeleteTimeslot}
                  day="today"
                />
              ))}
            </tbody>
          </table>

          <input
            type="button"
            value="Confirm Status Today"
            className="btn btn-primary m-2"
            onClick = {() => this.handleButton({day: "today"})}
          />
        <div className="alert alert-success" role="alert">
           {"Tomorrow: "+this.props.tomorrow}
        </div>
          <table className="table table-striped table-sm">
            <thead className="thead-dark">
              <tr>
                <th>Name</th>
                <th>Status</th>
                <th>Add Timeslot</th>
                <th>Transponder Mandatory?</th>
                <th>FL</th>
                <th>Start Hour</th>
                <th>Start Minutes</th>
                <th>End Hour</th>
                <th>End Minutes</th>
                <th>Delete Slot</th>

              </tr>
            </thead>
            <tbody align="center">
              {this.state["tomorrow"].golflist.map(golf => (
                <GolfUpdateRowNew
                  golf={golf.name}
                  slots={golf.slots}
                  key={golf.name+"-"+this.props.tomorrow}
                  tp={golf.tp}
                  status={golf.status}
                  FL={golf.FL}
                  sh={golf.sh}
                  sm={golf.sm}
                  eh={golf.eh}
                  em={golf.em}
                  curTime={this.state.curTime}
                  callbackUpdate={this.handleCallbackUpdate}
                  callbackOnChange={this.handleCallbackChange}
                  handleAddTimeslot={this.handleAddTimeslot}
                  handleDeleteTimeslot={this.handleDeleteTimeslot}
                  day="tomorrow"
                  />
              ))}
            </tbody>
          </table>

          <input
            type="button"
            value="Confirm Status Tomorrow"
            className="btn btn-primary m-2"
            onClick = {() => this.handleButton({day: "tomorrow"})}
          />



        </form>
      </div>
    );
  }
}

export default GolfUpdateForm;
